"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToolsModeContext = exports.ToolsModeProvider = exports.ToolsModeContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const hooks_1 = require("../hooks");
const initialState = {
    isOptionsExpanded: false,
    activeStickyID: '',
    isCutLineDrawn: false,
    isDetailedModel: false,
};
exports.ToolsModeContext = (0, react_1.createContext)([initialState, () => { }]);
function ToolsModeProvider({ children }) {
    const [state, dispatch] = (0, hooks_1.useToolsModeReducer)(initialState);
    return ((0, jsx_runtime_1.jsx)(exports.ToolsModeContext.Provider, { value: [state, dispatch], children: children }));
}
exports.ToolsModeProvider = ToolsModeProvider;
function useToolsModeContext() {
    return (0, react_1.useContext)(exports.ToolsModeContext);
}
exports.useToolsModeContext = useToolsModeContext;
